// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__24Dpl","productName":"Table_productName__1Rzqc"};